import { useEffect, useState } from "react";
import axios from "axios";
import careerpagebg from "../../../assets/career-development.png";
import Job_box from "./Job_box";

export default function Careers() {
  const [companyJobs, setCompanyJobs] = useState([]);
  const API_URL = process.env.REACT_APP_API_URL;
   useEffect(() => {
              window.scrollTo(0, 0); // Scroll to the top of the page
            }, []);
            const fadeInUp = {
              initial: { opacity: 0, y: 50 },
              whileInView: { opacity: 1, y: 0 },
              transition: { duration: 1 },
              viewport: { once: true, amount: 0.2 }, // triggers when 20% is visible
          };

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const endpoint = `${API_URL}/api/career/jobget`;
        console.log("Fetching jobs from:", endpoint); // Debug log
        const response = await axios.get(endpoint);
        console.log("Jobs fetched:", response.data); // Debug log
        setCompanyJobs(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };

    fetchJobs();
  }, [API_URL]);

  return (
    <div>
      {/* Banner Section */}
      <div
        style={{
          width: "100%",
          height: "250px",
          backgroundImage: `url(${careerpagebg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      ></div>

      {/* Job Listings */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          padding: "20px",
        }}
      >
        {companyJobs.length > 0 ? (
          companyJobs.map((job, index) => (
            <Job_box key={index} item={job} />
          ))
        ) : (
          <p>No jobs found.</p>
        )}
      </div>
    </div>
  );
}
 